import React from 'react';
import './HeroSession.css';

function HeroSession() {
  return (
    <div className="hero-section">
      <video className="background-video" autoPlay loop muted playsInline>
        <source src="./Pics/Herovidio.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
       
      <div className="overlay"></div>
      
      <div className="text-content">
        <p className="subtitle">
          Since The Last 2 Decades <span className="company-name">Centrex</span> marine services is
        </p>
        <p className="description">Providing Reliable And Modern</p>
        <p className="bold-description">Global Freight & Logistics Solutions</p>
      </div>
    </div>
  );
}

export default HeroSession;
